export default customElements.define('w-video', class Video extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'o-video';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `<div class="${styleSelector}__container" data-root></div>`
        };

        super(config);

        this.classList.add(this.styleSelector);
    }

    static get observedProps () {
        return [
            new wealthify.Prop('external', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('srcprop', {required: true}),
        ];
    }

    // TODO: Close event to be incorporated into Container base class
    // Ticket number: PDB-1011
    static get eventSettings () {
        return {subscriptions: {'container-close': this.prototype._pauseVideo}};
    }

    get propCallbacks() {
        return {
            external: () => this._prepareContent(),
            srcprop: () => this._prepareContent()
        };
    }

    get #srcprop () {
        const youtubeUrls = ['youtube', 'youtu.be'];
        const isYoutubeVideo = youtubeUrls.some((url) => this.srcprop.includes(url));
        const isAPIEnabled = this.srcprop.includes('enablejsapi');
        const hasParameters = this.srcprop.includes('?');

        return isYoutubeVideo && !isAPIEnabled
            ? `${this.srcprop}${hasParameters ? '&' : '?'}enablejsapi=1`
            : this.srcprop;
    }

    _prepareContent () {
        let element;

        this.dom.root.innerHTML = '';

        if (this.external) {
            element = this.dom.video = document.createElement('iframe');

            element.setAttribute('allowfullscreen', true);
            element.setAttribute('frameborder', 0);

            this.dom.root.classList.add(`${this.styleSelector}__container--external`);
            element.classList.add(`${this.styleSelector}__content--external`);

        } else {
            element = this.dom.video = document.createElement('video');

            element.setAttribute('controls', true);
            element.innerHTML += 'Your browser does not support the video tag';
        }

        element.setAttribute('src', this.#srcprop);
        element.classList.add(`${this.styleSelector}__content`);

        this.dom.root.appendChild(element);
    }

    _pauseVideo () {
        if (this.external) {
            // Command for YouTube API
            this.dom.video.contentWindow.postMessage(JSON.stringify({
                event: 'command', 
                func: 'pauseVideo' 
            }), '*');
        } else {
            this.dom.video.pause();
        }
    }

});